import { makeAutoObservable, runInAction } from 'mobx';
import type { ResponseDataRow } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi, ReportDto } from '@src/api';

export type ReportDtoDefId = Omit<ReportDto, 'id' | 'code'> & { id: string; code: string };

export type Filters = {
  reportGroup?: string;
  reportType?: string;
};

class ReportsStore {
  reports: ReportDtoDefId[] = [];

  api: CmApi;

  filters: Filters = {};

  breadcrumbs: string[] = [];

  fullSize = false;

  selectNode: ReportDtoDefId | null = null;

  selectedKeys: string[] = [];

  expandedKeys: string[] = [];

  checked: ResponseDataRow[] = [];

  isChanged = false; // флаг, что справочник изменился для проверки загрузки в fetchReferences

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  setIsChanged = (value: boolean) => {
    this.isChanged = value;
  };

  setFilters = (filter: Filters) => {
    this.filters = filter;
  };

  setBreadcrumbs = (value: string[]) => {
    this.breadcrumbs = value;
  };

  toggleFullSize = () => {
    this.fullSize = !this.fullSize;
  };

  setSelectNode = (value: ReportDtoDefId | null) => {
    this.selectNode = value;

    if (value === null) {
      this.fullSize = false;
    }
  };

  setSelectedKeys = (value: string[]) => {
    this.selectedKeys = value;
  };

  setExpandedKeys = (value: string[]) => {
    this.expandedKeys = value;
  };

  setChecked = (value) => {
    this.checked = value;
  };

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.report.getReports();

    runInAction(() => {
      this.reports = (data as ReportDtoDefId[])?.map((item) => ({ ...item, id: item.code })) ?? [];
      this.isChanged = false;
    });
    preloaderStore.preloader(false);
  };

  groupDelete = async (reports: string[]) => {
    preloaderStore.preloader(true, 'удаление...');
    const deleteCodes = reports.filter((code) => code);
    await this.api.report.deleteReport(deleteCodes);
    await this.fetch();
    preloaderStore.preloader(false);
  };

  clear = () => {
    this.filters = {};
    this.breadcrumbs = [];
    this.fullSize = false;
    this.selectNode = null;
    this.selectedKeys = [];
    this.expandedKeys = [];
    this.checked = [];
  };
}

export const reportsStore = new ReportsStore({ api: cmApi });
